// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9fe3194f"};